<template>
    <div class="form-general-messages grid grid__base" v-if="errors.length">
        <div class="form-general-messages--item" v-for="(error, errorIdx) in errors" :key="errorIdx">
            <span class="form-general-messages--text">
                {{ error }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: true,
            },
        },
    };
</script>
